<template>
  <div class="broadcaster" v-hotkey="keymap">
    <div v-if="$store.state.active">
      <div v-if="$store.state.id === $socket.client.id">
        
        <button v-if="$store.state.paused" @click="play" class="btn btn-light">
          <b-icon-play-fill></b-icon-play-fill>
        </button>
        <button v-else @click="pause" class="btn btn-light">
          <b-icon-pause-fill></b-icon-pause-fill>
        </button>

        <button @click="stop" class="btn btn-danger">
          <b-icon-stop-fill></b-icon-stop-fill>
        </button>
        
      </div>

      <div v-else>
        <button @click="publish" class="btn btn-light btn-danger">
          <b-icon-broadcast-pin></b-icon-broadcast-pin>
        </button>
      </div>
    </div>

    <div v-else-if="$store.state.active === false">
      <button @click="publish" class="btn btn-danger">
        <b-icon-broadcast-pin></b-icon-broadcast-pin>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      toggle() {
        this.$store.dispatch('toggle');
      },
      
      pause() {
        this.$store.dispatch('pause');
      },
      
      play() {
        this.$store.dispatch('play');
      },

      stop() {
        this.$store.dispatch('stop');
      },

      publish() {
        this.$store.dispatch('publish');
      }
    },

    computed: {
      keymap() {
        return {
          'space': this.toggle
        }
      }
    }
  }
</script>

<style scoped>
  .broadcaster {
    width: 100%;
    text-align: center;
  }

  .btn {
    margin-top: 0.5rem;
  }
</style>